<template>
  <div data-app>
    <div
      role="alert"
      v-bind:class="{ show: errors.length }"
      class="alert fade alert-danger"
    >
      <div class="alert-text" v-for="(error, i) in errors" :key="i">
        {{ error }}
      </div>
    </div>
    <v-card>
      <v-card-title>Announcement History</v-card-title>
      <v-data-table
        v-model="selected"
        :loading="loading"
        :headers="headers"
        :items="history"
        :search="search"
        item-key="id"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import api from "@/common/api.service";

export default {
  mounted() {
    let start = new Date();
    start.setMonth(start.getMonth() - 1);
    api
      .query("announcement_history", { params: { start: start.toISOString() } })
      .then(
        (response) =>
          (this.history = response.data.announcement_history.map((row) => ({
            ...row,
            id: `${row.net}_${row.start}`,
          })))
      )
      .catch((error) => (this.errors = [error]))
      .finally(() => (this.loading = false));
  },

  data: () => ({
    selected: [],
    headers: [
      { text: "Subnet", value: "net" },
      { text: "Reason", value: "reason" },
      { text: "Start", value: "start" },
      { text: "End", value: "end" },
    ],
    history: [],
    errors: [],
    loading: true,
    dialog: false,
    search: "",
  }),

  methods: {},
};
</script>
